export const environment = {
  production: true,
  bypass: false,
  baseURL:'https://buildwellserver.canopyapp.net/',
  uploadURL:'https://buildwellserver.canopyapp.net/',
  workflow: require('./workflow.json'),
  firebase:{
    apiKey: "AIzaSyCYUWEBOcqOOTrQtsPle-NPzTCxEw9ISH8",
    authDomain: "wllsuite-72fab.firebaseapp.com",
    databaseURL: "https://wllsuite-72fab.firebaseio.com",
    projectId: "wllsuite-72fab",
    messagingSenderId: "465863272723",
    appId: "1:465863272723:web:ada7706d820d89b01cd2e6"
  }
};



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/environments/environment.ts